import { HTTPService } from "./httpService";
import { isAllDealerships } from "../util/locationUtils";

const API = new HTTPService();

// Cache dealerships to avoid refetching
let cachedDealerships = {};

const DealerGroupService = {

    /**
     * Fetch dealerships belonging to a dealer group.
     * Results are cached by groupId.
     */
    getDealerships: async (groupId) => {
        if (cachedDealerships[groupId]) {
            return cachedDealerships[groupId];
        }
        const { data } = await API.get(`/dealer-groups/${groupId}/dealerships`);
        const dealerships = (data || []).map(d => ({
            dealer_id: d.dealer_id,
            dealer_name: d.dealer_name || d.name
        }));
        cachedDealerships[groupId] = dealerships;
        return dealerships;
    },

    /**
     * Fetch payments for all dealerships in a group using the aggregation endpoint.
     * Each transaction is tagged with dealer_name from the dealerships list.
     */
    getGroupPayments: async (groupId, dealerId) => {
        const dealerships = await DealerGroupService.getDealerships(groupId);

        // Build a lookup map for dealer names
        const dealerNameMap = {};
        dealerships.forEach(d => {
            dealerNameMap[d.dealer_id] = d.dealer_name;
        });

        let url = `/dealer-groups/${groupId}/payments`;
        if (!isAllDealerships(dealerId)) {
            url += `?dealerId=${dealerId}`;
        }
        const { data } = await API.get(url);
        const payments = data || [];

        // Tag each transaction with dealer_name from our dealerships list
        return payments.map(tx => ({
            ...tx,
            dealer_name: tx.dealer_name || dealerNameMap[tx.dealer_id] || 'Unknown'
        }));
    },

    /**
     * Update invoice metadata (PO number).
     */
    updateInvoiceMetadata: async (invoiceId, PO) => {
        await API.put(`/invoices/meta/${invoiceId}`, { invoiceId, PO });
    },

    /**
     * Clear cached dealerships (e.g., on logout).
     */
    clearCache: () => {
        cachedDealerships = {};
    }
};

export default DealerGroupService;
